// extracted by mini-css-extract-plugin
export var carrierIcon = "_ua-0";
export var carrierLogo = "_ua-1";
export var detailsSection = "_ua-2";